import useFlagOverrides from "@components/ui/flag-overrides/useFlagOverrides";
import { UseTRPCQueryResult } from "@trpc/react-query/shared";
import { trpc } from "@util/trpc/trpcClient";
import { Flag, FlagTypes } from "@webapp/shared";

const FLAGS_TRPC_OPTS = {
  // Send cookies cross-domain
  credentials: "include",
  // Cache response for 10 minutes
  staleTime: 10 * 60 * 1000,
};

export function useFlags<T = FlagTypes>(options?: {
  select?: (flags: FlagTypes) => T;
}) {
  const { select } = options || {};
  const userFields = {
    userAgent: navigator.userAgent,
    locale: navigator.languages ? navigator.languages[0] : navigator.language,
  };

  return trpc.flags.getFlags.useQuery(
    { userFields },
    {
      ...FLAGS_TRPC_OPTS,
      select: (flags) => (select ? select(flags) : flags),
    },
  ) as UseTRPCQueryResult<
    typeof select extends undefined ? FlagTypes : T,
    Error
  >;
}

export function useFlag<T extends Flag>(flag: T) {
  const { overrides } = useFlagOverrides();

  return useFlags({
    select: (flags) => overrides?.[flag] ?? flags[flag],
  });
}
